import { gql } from "@apollo/client";

const VIEWER = gql`
  {
    viewer {
      username
      firstName
      email
      groups {
        name
      }
      language
    }
  }
`;

export default VIEWER;
